import React from "react";
import {Navigate, useRoutes} from "react-router";
import ListOfExperts from "../features/experts/ListOfExperts.jsx";
import ExpertPage from "../features/experts/ExpertPage";
import AppDisclosureOfficer from "../apps/disclosure_officer/appDisclosureOfficer";
import ListOfDisclosures from "../apps/disclosure_officer/pages/ListOfDisclosures/ListOfDisclosures";
import DisclosureReviewSplitPage
    from "../apps/disclosure_officer/pages/DisclosureReviewSplitPage/DisclosureReviewSplitPage";
import {routesChat} from "./routesChat";
import FeedsPage from "../features/chat/feeds/FeedsPage";
import FeedItems from "../features/chat/feeds/components/FeedItems";
import ReadbookPage from "../apps/policymaker/pages/readbooks/ReadbookPage";
import KnowledgeBasePage from "../features/knowledgeBase/KnowledgeBasePage";
import EntitiesList from "../features/knowledgeBase/EntitiesList";
import EntityDetailPage from "../features/knowledgeBase/EntityDetailPage";
import WhiteboardsListPage from "../features/whiteboards/WhiteboardsListPage";
import WhiteboardPage from "../features/whiteboards/WhiteboardPage";
import LegacyWhiteboardRedirect from "./LegacyWhiteboardRedirect";
import HelpPage from "../features/help/HelpPage";
import WorkflowPage from "../features/workflow/WorkflowPage";

const routesDisclosureOfficer = [
    ...routesChat,
    {
        path: "/",
        element: <AppDisclosureOfficer/>,
        children: [
            {index: true, element: <Navigate to="disclosures" replace/>},
            {path: "disclosures", element: <ListOfDisclosures/>},
            {path: "experts", element: <ListOfExperts/>},
            {path: "experts/:handle", element: <ExpertPage/>},
            {path: "charts", element: <WhiteboardsListPage/>},
            {
                path: "feed",
                element: <FeedsPage/>,
                children: [
                    {
                        path: ":feedId", element: <FeedItems/>,
                        children: [
                            {path: ":sourceSegmentId", element: <ReadbookPage/>},
                        ],
                    },],
            },
            {path: "help", element: <HelpPage/>},
            {path: "workflow", element: <WorkflowPage/>},
            {
                path: "kb",
                element: <KnowledgeBasePage/>,
                children: [
                    {index: true, element: <EntitiesList/>},
                    {path: ":entityId", element: <EntityDetailPage/>},
                ],
            },
        ],
    },
    {
        path: "/disclosures/:reportId",
        element: <DisclosureReviewSplitPage/>,
    },
    {
        path: "/charts/:whiteboardId",
        element: <WhiteboardPage/>,
    },
    {path: "/whiteboards", element: <Navigate to="/charts" replace/>},
    {path: "/whiteboards/*", element: <LegacyWhiteboardRedirect/>},
    {path: "*", element: <Navigate to="/disclosures" replace/>},
];

export function RoutesDisclosureOfficer() {
    return useRoutes(routesDisclosureOfficer);
}